var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('input-dropdown', {
    attrs: {
      "items": _vm.items,
      "qa": _vm.qa,
      "value": _vm.value,
      "label": _vm.label,
      "isRequired": _vm.isRequired
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', $event);
      }
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }